const $74aebeb5449e6ba2$export$be623a1d3e871e62 = document.querySelector("#screen");
const $74aebeb5449e6ba2$export$fe37e88a9b661478 = document.querySelector(".btns");


function $9e008f3a45698198$export$589f696bd8531d3d(screen) {
    screen.value = "";
// calculate = 0;
}


function $3b5eade029884756$export$f4ab26487cf6362f(screen) {
    screen.value = screen.value.slice(0, -1);
}


function $2072670d6abbee8b$export$660b2ee2d4fb4eff(exp) {
    const regex = /(\d+\.?\d*|\+|\-|\*|\/|%|\(|\))/g;
    return exp.match(regex).map((token)=>/\d/.test(token) ? parseFloat(token) : token);
}


function $46d2f16018226e9a$export$6a5f189fbd1db290(tokens) {
    const precedence = {
        "+": 1,
        "-": 1,
        "*": 2,
        "/": 2,
        "%": 2
    };
    const result = [];
    const operators = [];
    tokens.forEach((token)=>{
        if (typeof token === "number") result.push(token);
        else if ("+-*/".includes(token)) {
            while(operators.length && precedence[operators[operators.length - 1]] >= precedence[token])result.push(operators.pop());
            operators.push(token);
        }
    });
    while(operators.length)result.push(operators.pop());
    return result;
}


function $d5b5e06532866216$export$9ea73367ae41ae3c(result) {
    const stack = [];
    result.forEach((token)=>{
        if (typeof token === "number") stack.push(token);
        else {
            const b = stack.pop();
            const a = stack.pop();
            switch(token){
                case "+":
                    stack.push(a + b);
                    break;
                case "-":
                    stack.push(a - b);
                    break;
                case "*":
                    stack.push(a * b);
                    break;
                case "/":
                    stack.push(a / b);
                    break;
                case "%":
                    stack.push(a * (b / 100));
                    break;
            }
        }
    });
    return stack[0];
}


function $61d1ce52e4b18227$export$8b15a0c6feaf00c(exp) {
    let tokens = (0, $2072670d6abbee8b$export$660b2ee2d4fb4eff)(exp);
    let result = (0, $46d2f16018226e9a$export$6a5f189fbd1db290)(tokens);
    return (0, $d5b5e06532866216$export$9ea73367ae41ae3c)(result);
}


function $c15d8ae45ba163aa$export$fb4685088aadaaa1(screen) {
    let exp = screen.value.replace(/x/g, "*").replace(/÷/g, "/").replace(/%/g, "*0.01");
    try {
        const result = (0, $61d1ce52e4b18227$export$8b15a0c6feaf00c)(exp);
        if (Number.isInteger(result)) screen.value = result;
        else screen.value = result.toFixed(2);
    } catch (e) {
        screen.value = "Error";
    }
}


let $e73bf42412feb220$var$calculate = 0;
(0, $74aebeb5449e6ba2$export$fe37e88a9b661478).addEventListener("click", function(e) {
    e.preventDefault();
    if (e.target.tagName === "BUTTON") {
        let key = e.target.textContent || e.target.innerText;
        if (key === "AC") (0, $9e008f3a45698198$export$589f696bd8531d3d)((0, $74aebeb5449e6ba2$export$be623a1d3e871e62));
        else if (key === "CE") (0, $3b5eade029884756$export$f4ab26487cf6362f)((0, $74aebeb5449e6ba2$export$be623a1d3e871e62));
        else if (key === "=") (0, $c15d8ae45ba163aa$export$fb4685088aadaaa1)((0, $74aebeb5449e6ba2$export$be623a1d3e871e62));
        else (0, $74aebeb5449e6ba2$export$be623a1d3e871e62).value += key;
    }
});


//# sourceMappingURL=index.9fc6b90f.js.map
